import { render, staticRenderFns } from "./ItemAttributeFilterStockStatus.vue?vue&type=template&id=92dc21ea&scoped=true"
import script from "./ItemAttributeFilterStockStatus.vue?vue&type=script&lang=ts"
export * from "./ItemAttributeFilterStockStatus.vue?vue&type=script&lang=ts"
import style0 from "./ItemAttributeFilterStockStatus.vue?vue&type=style&index=0&id=92dc21ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dc21ea",
  null
  
)

export default component.exports